import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams, useLocation } from "react-router-dom";

import './styles.scss';

import {
    AppLayout, HelpPanel, Icon, BreadcrumbGroup, Box, Alert, ExpandableSection, Tiles,
    Container, Header, ColumnLayout, Spinner, Link, Tabs, Button, Table, SpaceBetween, Modal, FileUpload, Flashbar,
    RadioGroup,
    FileInput,
    Grid,
    SegmentedControl,
    Popover,
    Checkbox
} from '@amzn/awsui-components-react';
import SideNav from './SideNav';
import { useAuth } from "../../context/AuthContextProvider";
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import Amplify, { Storage } from 'aws-amplify';
import { getFriscoS3Config } from 'src/utilities/AWSServices';

import MJEmonitoringSampleFile from '../../images/MJEMonitoringSampleFile.png'
import { PORTAL } from "src/constants/AppConstants";
import { setCurrentAppId } from '../../store/userAuthSlice';
import * as XLSX from 'xlsx';
import { getMappingById, getProcessById, getFRISCOPreValidationResults, friscoSubmit, getFRISCOPreValidationMatchingExcelSheetResults, onMatchResults, getNotification, createAuditLog, getEmployeeDetailsByLogin } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus"
import { FRISCO_NEGATIVE_STATUS_FOR_UPLOAD, FRISCO_POSITIVE_STATUS, FRISCO_STATUS, PROCESS_KEYS } from './Constants';
import { configureFriscoS3, configureGenericAppSync, configureGenericS3 } from 'src/context/AuthContextUtility'
import { isUploaderAllowed } from './AccessUtilities';
import { request as requestPlugin } from 'src/plugins/CorpReportingUploadAccess'
import { request as requestViewPlugin, disabled as isDisabledPlugin, getFilteredWbOptions  as getFilteredWbOptionsPlugin} from 'src/plugins/CorpReportingViewOptions'
import { getCurrentQuarter, getQuarterForUpload } from '../CorpReporting/Utility';
import { checkIfPortalAdmin, checkIfSupportAdmin } from 'src/checkPageAccess';
import { formNotificationItems } from './NotificationUtilities';
import { getAssociatedTANCSession, getAssociatedTANCSessionSync, tancAssociationStatus, updateTANCLock } from 'src/utilities/AppSyncPlusAPIs';
import TANCSession from '../TANC/TANCSession';
import appSettings from '../CorpReporting/app_settings';
import { useBreadcrumb } from '../../generic-components/Breadcrumb/useBreadcrumb';
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { getDisplayName } from '../utils/displayNameUtils';
import { updateProcessComment } from 'src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus';
import ProcessCommentSection from '../Templates/components/ProcessCommentSection';

export default (props) => {
    const userId = useSelector((globalState) => globalState.auth.userId)
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const history = useHistory();
    const userAuthenticationDetails = useAuth();
    const userLDAPS = userAuthenticationDetails.USER_LDAP_GROUPS;
    let { id: paramId } = useParams();
    let { pid: paramPid } = useParams();
    
    const id = props.id || paramId;
    const pid = props.pid || paramPid;
    const [processData, setProcessData] = useState({})
    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState();
    const [mappingId, setMappingId] = useState('');
    const dispatch = useDispatch()
    const [activeTabId, setActiveTabId] = useState("first");
    const [isFileSelected, setIsFileSelected] = useState(false);
    const [showFileNotSeleted, setShowFileNotSeleted] = useState(false);
    const currentAppId = useSelector((globalState) => globalState.auth.currentAppId)
    const isCurrentAppAuthorised = useSelector((globalState) => globalState.auth.isCurrentAppAuthorized)
    const corpReportingQuarter = useSelector((globalState) => globalState.auth.corpReportingQuarter)
    const [showLoadingIcon, setShowLoadingIcon] = useState(false);
    const [columnsList, setColumnsList] = useState({})
    const [items, setItems] = useState([])
    const [previewItems, setPreviewItems] = useState([])
    const [uploadedFileName, setUploadedFileName] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [mainErrorMessage, setMainErrorMessage] = useState('');
    const [missingFields, setMissingFields] = useState(new Set());
    const [colsNotInRequiredOrder, setColsNotInRequiredOrder] = useState(false);
    const [colCountMoreThanExpected, setColCountMoreThanExpected] = useState(false);
    const [comparisonValidationErrors, setComparisonValidationErrors] = useState({});
    const [emptyRowsValidationResult, setEmptyRowsValidationResult] = useState({});
    const [emptyColumnIndices, setEmptyColumnIndices] = useState([]);
    const [inputFiles, setInputFiles] = useState([]);
    const [supportedFormats, setSupportedFormats] = useState('.csv');
    const [loadingMessage, setLoadingMessage] = useState('loading, please wait..');
    const [showUploadBtn, setShowUploadBtn] = useState(false)
    const [fileReference, setFileReference] = useState('');
    const [inputSheets, setInputSheets] = useState([]);
    const [selectedSheet, setSelectedSheet] = useState('');
    const [disableProceedButton, setDisableProceedButton] = useState(true)
    const [backUrl, setBackUrl] = useState(null)
    const [taskId, setTaskId] = useState(null)
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [uploadAccessForTheQuarter, setUploadAccessForTheQuarter] = useState(false);
    const [rawFile, setRawFile] = useState(null)
    const [rawFileData, setRawFileData] = useState(null)
    const stageSessionId = useRef()
    const stageSessionFileExt = useRef()
    // sometimes updating setSelectedSheet is not reflecting when making a validation request since that is async function also. hence using this copy variable
    const stageSessionSelectedSheet = useRef()
    const [providedCoulumns, setProvidedCoulumns] = useState([])
    const [comments, setComments] = useState(null)
    const [notificationBarItems, setNotificationBarItems] = useState([])
    const [soxAuditFailed, setSoxAuditFailed] = useState(false)
    const [wbType, setWbType] = useState(false)
    const [supportingDocs, setSupportingDocs] = useState([])
    const [shouldShowWbSelection, setShouldShowWbSelection] = useState(false)
    const [shouldShowPdfUpload, setShouldShowPdfUpload] = useState(false)
    const [tancInfo, setTancInfo] = useState(null)
    const [sessionDetails, setSessionDetails] = useState(null)
    // Initialize uploadSegment based on URL parameter to avoid flash when loading inline edit
    const [uploadSegment, setUploadSegment] = useState(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const modeParam = urlParams.get('mode');
        
        if (props.disableAppLayout && modeParam === 'inline_edit') {
            return 'tanc';
        }
        return 'upload';
    })
    const [approverNames, setApproverNames] = useState([]);
    const [missingMandatoryDocs, setMissingMandatoryDocs] = useState([])
    const [isFriscoDisabled, setIsFriscoDisabled] = useState(false)
    const [disabledMessages, setDisabledMessages] = useState([])
    const [hasUploaderAccess, setHasUploaderAccess] = useState(true)
    const [isCommentSubmitting, setIsCommentSubmitting] = useState(false)
    const [requireCertificationCheck, setRequireCertificationCheck] = useState(false)
    const [hideLoadTable, setHideLoadTable] = useState(false)
    const [certificationChecked, setCertificationChecked] = useState(false)
    const { breadcrumbItems, generateBreadcrumbs } = useBreadcrumb();
    const ln = useLocation()
    useVisibleTimeTracker([{
        metricName : 'actionPerformedBy',
        metricValue : userId,
        metricType : METRIC_TYPE.STRING,
        isMonitor : true
    },
    {
        metricName : 'pagePath',
        metricValue : `${ln.pathname}`,
        metricType : METRIC_TYPE.STRING,
        isMonitor : true
    }
    ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.FRISCO);
    // Comment functionality - using Redux selector
    const isPortalAdmin = useSelector((globalState)=>globalState.auth.isPortalAdmin)
    const isSupportAdmin = useSelector((globalState)=>globalState.auth.isSupportAdmin)

    useEffect(() => {
        configureFriscoS3()
        if (pid) {
            loadData();
        }
        if (id) {
            dispatch(setCurrentAppId(id))
        }
        setBackUrl(getParam('back'))
        setTaskId(getParam('taskId'))
        return () => {
            // this now gets called when the component unmounts
            configureGenericS3()
        };
    }, []);



    useEffect(() => {
        configureFriscoS3()
        return () => {
            // this now gets called when the component unmounts
        };
    }, [isCurrentAppAuthorised]);

    useEffect(() => {
        stageSessionSelectedSheet.current = selectedSheet
        if (selectedSheet) {
            setDisableProceedButton(false)
        } else {
            setDisableProceedButton(true)
        }
        return () => {
            // this now gets called when the component unmounts
        };
    }, [selectedSheet]);

    useEffect(() => {
        if (isAuthorized === true || isAuthorized === false) {
            setIsCheckingAccess(!isCheckingAccess);
        }
    }, [isAuthorized]);


    const getParam = (key) => {
        const search = props?.location?.search;
        const params = new URLSearchParams(search);
        const value = params.get(key);
        return value;
    }

    const getProcessDisplayName = () => {
        const aliasParam = getParam('alias');
        return getDisplayName(aliasParam, processData[PROCESS_KEYS.process_name], processData[PROCESS_KEYS.label]);
    }

    const loadData = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
            console.log("hitting load")

        try {
        setLoadingMessage("loading, please wait...")
        setShowLoadingIcon(true);
        setShowUploadBtn(false)
        // setProcessData()
        await Promise.all([
        new Promise((resolve, reject) => {
            getNotification(pid, 'FRISCO_PROCESS', function onSuccess(response) {
            formNotificationItems(response, setNotificationBarItems)
            JSON.parse(response.data.getNotification).forEach((notification, index) => {
                if (notification.notification_type == 'FRISCO_2PR_ALIAS_VALIDATION_ERROR') {
                    setSoxAuditFailed(true)
                    setErrorMessage("Minimum of 2 approvers required.")
                } else if (notification.info?.includes("APPROVER")) {
                    setSoxAuditFailed(true)
                    setErrorMessage(`The approver list has to be updated. Please contact process owner.`)
                } else if (notification.info?.includes(userId) &&
                    (notification.notification_type == 'ALIAS_PATROL_COST_CENTER_MISMATCH'
                        || notification.notification_type == 'ALIAS_PATROL_MANAGER_LOGIN_MISMATCH'
                        || notification.notification_type == 'ALIAS_PATROL_JOB_STATUS_MISMATCH')) {
                    setSoxAuditFailed(true)
                    setErrorMessage(`${notification.notification_message} Please contact process owner.`)
                }
            })

            resolve();

        }, function onFailure(response) {
            reject();
        })
        }),
        new Promise((resolve, reject) => {
            tancAssociationStatus(pid, 'FRISCO', function onSuccess(response) {
            setTancInfo(response?.data?.tancAssociationStatus)
            if (response?.data?.tancAssociationStatus?.status) {
                // Active status - get association id
                getAssociatedTANCSession(pid, 'FRISCO', function onSuccess(response) {
                    // Check URL parameters to determine the mode when in iframe
                    const modeParam = getParam('mode');
                    if (props.disableAppLayout && modeParam === 'inline_edit') {
                        setUploadSegment('tanc')
                    } else if (props.disableAppLayout) {
                        // Default to upload mode when in iframe without specific mode parameter
                        setUploadSegment('upload')
                    } else {
                        // Original behavior for non-iframe context
                        setUploadSegment('tanc')
                    }
                    setSessionDetails(response?.data?.getAssociatedTANCSession?.items?.[0])
                    resolve();
                }, function onFailure(response) {
                    reject();
                })
            } else {
                resolve();
            }
            
        }, function onFailure(response) {
            reject();
        })
            }),
        new Promise((resolve, reject) => {
                getProcessById(pid, async function onSuccess(response) {
            const r = response.data.getProcessByIDV2RDS
            if(r[PROCESS_KEYS.schema] && r[PROCESS_KEYS.schema].length > 0){
                r[PROCESS_KEYS.schema].sort((a, b) => a.column_index - b.column_index)
            }
            setProcessData(r)
            // Move hide load table function to just after getting process id data, 
            // This is now not dependant on permissions etc
            requestViewPlugin({ appId: id, stage: currentStage }, function onResponse(response) {
                setHideLoadTable(response?.hideLoadTable)
            })
            
            // Update breadcrumbs based on where user came from
            const backUrl = getParam('back');
            const deliverableRef = r[PROCESS_KEYS.process_name] || `Process ${pid}`;
            await generateBreadcrumbs(backUrl, deliverableRef, id, pid);
            setSupportedFormats(getSupportedFormats(r))
            if (r[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift' && FRISCO_NEGATIVE_STATUS_FOR_UPLOAD.includes(r[PROCESS_KEYS.status])) {
                setShowLoadingIcon(false);
                setShowUploadBtn(false)
                setErrorMessage(`Cannot upload input file. The table creation status is : ${r[PROCESS_KEYS.status]}`)
                resolve();
                return;
            }
            
            
            let isAllowed = isPortalAdmin || await checkIfPortalAdmin(userId, currentStage)
            if (!isAllowed) {
                isAllowed = isSupportAdmin || await checkIfSupportAdmin(userId, currentStage)
            }

            // temporary if condition for internal testing - the portal/support admin conditions are ignored for CRA app to simulate normal acc users permissions
            if (currentAppId == appSettings[currentStage].appId) {
                isAllowed = false
            }
            if (!isAllowed) {
                isAllowed = await isUploaderAllowed(r, userId, currentStage)
            }
            if (!isAllowed) {

                setShowLoadingIcon(false);
                setShowUploadBtn(false)
                if (currentAppId == appSettings[currentStage].appId) {
                    setErrorMessage("You don't have permission to perform an upload action. You are not part of the Uploader group for this deliverable  If you believe you should have access please contact the SEC team to request membership in the appropriate group")
                }else{
                    setErrorMessage("If you believe you should have access please contact the SEC team to request membership in the appropriate group")
                }
            } else {
                // Check uploader access
                setHasUploaderAccess(isAllowed);
                
                getMappingById(id, pid, function onSuccess(response) {
                    setMappingId(response.data.getMappingIDV2.mapping_id)
                    setShowLoadingIcon(false);
                    setShowUploadBtn(true)
                },
                    function onFailure(response) {
                        // setErrorMessage("Could not get app mapping information")
                        setShowLoadingIcon(false);
                        setShowUploadBtn(true)
                    })
                let quarter = getQuarterForUpload()
                requestPlugin({ appId: id, processId: pid, stage: currentStage, group: response.data.getProcessByIDV2RDS[PROCESS_KEYS.group_id], quarter: quarter }, function onResponse(response) {
                    setUploadAccessForTheQuarter(response.result)
                    if (!response.result) {
                        setErrorMessage(` A process is either in-progress or complete. Current status is '${response.message}'`)
                    }
                    if (response.comments) {
                        setComments(response.comments)
                    }
                })
                requestViewPlugin({ appId: id, stage: currentStage }, function onResponse(response) {
                    setShouldShowWbSelection(response?.allowWBSelection)
                    setShouldShowPdfUpload(response?.allowSupportingDocUpload)
                    setRequireCertificationCheck(response?.requireCertificationCheck)
                })
                isDisabledPlugin({ appId: id, stage: currentStage, info: r }, function onResponse(response) {
                    let messages = []
                    if(response?.disabled){
                        setIsFriscoDisabled(true)
                        messages.push('This deliverable is disabled and not required for this quarter. If you believe this not to be correct, please contact the SEC team')
                    }
                    if(response?.annualOnly && getCurrentQuarter()!="Q1"){
                        setIsFriscoDisabled(true)
                        messages.push('This deliverable is ANNUAL ONLY and not required for this quarter. If you believe this not to be correct, please contact the SEC team')
                    }

                    setDisabledMessages(messages)
                })
                if(r[PROCESS_KEYS.environment] === "Transfer_S3_Workdocs"){
                    setShouldShowPdfUpload(true)
                }
            }
            resolve();
        }, function onFailure(response) {
            setErrorMessage("Could not load process information")
            setShowLoadingIcon(false);
            setShowUploadBtn(true)
            reject();
        }) 
            })])
        
    } finally {
        if(!pageLoadTime.isStopped) {
        stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.FRISCO)
        }
    }
}

    const getAllowedFileFormats = () => {
        if (processData && processData.hasOwnProperty(PROCESS_KEYS.file_types) && processData[PROCESS_KEYS.file_types]) {
            return processData[PROCESS_KEYS.file_types]
        }
        return []
    }

    const getMandatoryColumnNames = () => {
        let mandatoryColumns = new Set()

        if (processData && processData.hasOwnProperty(PROCESS_KEYS.schema)) {
            processData[PROCESS_KEYS.schema].forEach((item) => {
                mandatoryColumns.add(item['column_name'])
            })
        }
        return mandatoryColumns
    }

    useEffect(() => {
        const fetchApprovers = async () => {
            if (processData && processData.hasOwnProperty(PROCESS_KEYS.approvers) && processData[PROCESS_KEYS.approvers]?.length > 0) {
                setApproverNames(processData[PROCESS_KEYS.approvers])
            }
        };

        fetchApprovers();
    }, [processData]);


    const isAllowedFileFormat = (format, allowedFileFormats) => {
        let isAllowed = false
        // console.log(format)
        if (!format) {
            isAllowed = false
        }
        let supportedFormats = []
        for (let i = 0; i < allowedFileFormats.length; i++) {
            if (allowedFileFormats[i] == 'CSV') {
                supportedFormats.push('text/csv')
                supportedFormats.push('text/plain') 
                supportedFormats.push('text/x-csv')
                supportedFormats.push('application/vnd.ms-excel')
                supportedFormats.push('application/csv')
                supportedFormats.push('application/x-csv')
                supportedFormats.push('text/comma-separated-values')
                supportedFormats.push('text/x-comma-separated-values')
                supportedFormats.push('text/tab-separated-values')
            } else if (allowedFileFormats[i] == 'Excel') {
                supportedFormats.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                supportedFormats.push('application/vnd.ms-excel.sheet.macroenabled.12')
                supportedFormats.push('application/vnd.ms-excel')
                supportedFormats.push('application/msexcel')
            } else if (allowedFileFormats[i] == 'PDF') {
                supportedFormats.push('application/pdf')
                supportedFormats.push('application/x-pdf')
                supportedFormats.push('application/acrobat')
            } else if (allowedFileFormats[i] == 'Word') {
                supportedFormats.push('application/msword')
                supportedFormats.push('application/vnd.openxmlformats-officedocument.wordprocessingml.document')
                supportedFormats.push('application/vnd.ms-word.document.macroEnabled.12')
                supportedFormats.push('application/doc')
                supportedFormats.push('application/docx')
            }
        }
        isAllowed = supportedFormats.some(item => format === item);
        return isAllowed
    }
    const validateInputFileFormat = (file) => {
        let allowedFileFormats = getAllowedFileFormats()
        let isAllowed = isAllowedFileFormat(file?.type, allowedFileFormats)
        if (!file?.type) {
            throw new Error("Please upload an input file")
        }
        if (!isAllowed) {
            throw new Error(`File format is not allowed : ${file?.type}`);
        }
        return isAllowed
    }

    const validateEmptyContents = (rowData) => {
        if (!rowData || rowData.length == 0) {
            throw new Error("The inputs rows are empty")
        }
    }

    const resetValidationErrorLogs = () => {
        setProvidedCoulumns([])
        setMissingFields(new Set())
        setColCountMoreThanExpected(false)
        setColsNotInRequiredOrder(false)
        setEmptyRowsValidationResult({})
        setEmptyColumnIndices([])
        setComparisonValidationErrors({})
    }

    const postDataSelection = async () => {
        setLoadingMessage("validating the uploaded file, please wait...")
        setDisableProceedButton(true)
        setShowLoadingIcon(true)
        resetValidationErrorLogs()
        onMatchResults(stageSessionId.current, function onResult(result) {
            let validationResponse = JSON.parse(result.value.data.onMatchResults.payload)
            setProvidedCoulumns(validationResponse.normalised_columns)
            setMissingFields(new Set(validationResponse.missing_fields))
            setColCountMoreThanExpected(validationResponse.column_count_more_than_expected)
            setColsNotInRequiredOrder(validationResponse.columns_not_in_required_order)
            setEmptyRowsValidationResult(validationResponse.empty_rows_present || {})
            setEmptyColumnIndices(validationResponse.empty_columns_present || [])
            // Handle comparison validation errors
            if (validationResponse.comparison_validation_errors) {
                setComparisonValidationErrors(validationResponse.comparison_validation_errors)
            }

            if (validationResponse.missing_fields.size >= 1 || validationResponse.columns_not_in_required_order || validationResponse.column_count_more_than_expected || validationResponse.comparison_validation_errors) {
                setShowLoadingIcon(false)
                return
            }
            const definitions = validationResponse.normalised_columns.map(colName => ({
                id: colName,
                header: colName,
                cell: item => item[colName] || '-'
            }))
            setColumnsList(definitions)
            setPreviewItems(validationResponse.top_columns)
            setShowLoadingIcon(false)
            setDisableProceedButton(false)
            setActiveTabId('second')
        }, function onFailure(error) {
            console.log(error)
        })

        await new Promise(resolve => setTimeout(resolve, 1000));
        getFRISCOPreValidationResults(stageSessionId.current, stageSessionFileExt.current, pid, stageSessionSelectedSheet.current, function onSuccess(response) {

        }, function onFailure(error) {

        })


    }

    const processExcelSheet = async () => {
        try {
            setErrorMessage('')
            const file = inputFiles[0]
            setRawFile(file)
            postDataSelection()
        } catch (error) {
            setErrorMessage(error?.message)
            setLoadingMessage("")
            setShowLoadingIcon(false)
        }
    }

    const validateFileSize = (fileDesc) => {
        if (fileDesc.size / 1000000 >= 200) {
            throw ({ error: 'FILE MAX LIMIT', message: "Max file limit is 200MB" })
        } else {
            setErrorMessage()
        }
    }

    const changeHandler = async (inputFiles, tancSupportingFiles = []) => {
        try {
            setDisableProceedButton(true)
            if(processData[PROCESS_KEYS.environment] === "Transfer_FAST_RedShift"){
                setShowLoadingIcon(true);
            }
            setErrorMessage('')
            setIsFileSelected(true)
            setShowFileNotSeleted(false)
            setSelectedSheet('')
            setWbType(null)
            setSupportingDocs([])
            stageSessionSelectedSheet.current = ''
            const file = inputFiles[0]
            validateFileSize(file)
            validateInputFileFormat(file)
            setUploadedFileName(file.name)

            let stageSession = uuidv4()
            stageSessionId.current = stageSession
            let fileExt = file.name.split('.').pop()
            stageSessionFileExt.current = fileExt
            let folder = `stage/${stageSession}/`
            let fileName = folder + stageSession + `.${fileExt}`
            let level = "public"
            let prefix = 'frisco/'
            configureFriscoS3()
            let putResp; 
            if(processData[PROCESS_KEYS.environment] === "Transfer_FAST_RedShift"){
                setLoadingMessage("uploading the file, please wait...")
                putResp = await Storage.vault.put(fileName, file, {
                    tagging: `userId=${userId}&app_id:${id}&process_id:${pid}&mappingId=${mappingId}&type=${file.type}`,
                    level: level,
                    customPrefix: { public: prefix },
                    acl: 'bucket-owner-full-control'
                })
            }
                // Validate sheets only if it is a transfer to fast redshift
            for (let i in tancSupportingFiles) {
                let supportingFile = tancSupportingFiles[i]
                let folder = `stage/${stageSessionId.current}/supportingDocuments/`
                let supportingFileName = folder + `tanc_delta_${supportingFile.name}`
                let supporting = await Storage.vault.put(supportingFileName, supportingFile, {
                    tagging: `userId=${userId}&app_id:${id}&process_id:${pid}&mappingId=${mappingId}&type=${file.type}`,
                    level: level,
                    customPrefix: { public: prefix },
                    acl: 'bucket-owner-full-control'
                })
            }

            resetValidationErrorLogs()
            if (processData[PROCESS_KEYS.environment] === "Transfer_FAST_RedShift" && putResp && putResp.hasOwnProperty('key')) {
                if (stageSessionFileExt.current == 'csv') {
                    postDataSelection()
                } else if (stageSessionFileExt.current.includes("xl") ){
                    setLoadingMessage("fetching matching sheets from the excel, please wait...")
                    onMatchResults(stageSessionId.current, function onResult(result) {
                        let response = JSON.parse(result.value.data.onMatchResults.payload)
                        let sheetsWithValidSchema = response?.validSheets?.map(colName => ({
                            label: colName,
                            value: colName
                        }))
                        setInputSheets(sheetsWithValidSchema)
                        setShowLoadingIcon(false);
                        if (sheetsWithValidSchema.length <= 0) {
                            setErrorMessage("There are no sheets that match the required schema. Please upload valid file.")
                        } else if (sheetsWithValidSchema.length == 1) {
                            setSelectedSheet(sheetsWithValidSchema[0].value)
                        }
                    }, function onFailure(error) {
                        console.log(error)
                    })

                    await new Promise(resolve => setTimeout(resolve, 1000));

                    // call excel API and get sheets
                    getFRISCOPreValidationMatchingExcelSheetResults(stageSessionId.current, stageSessionFileExt.current, pid, function onSuccess(response) {
                    }, function onFailure(error) {
                        setErrorMessage("Sheet validation failed", error?.message)
                        setShowLoadingIcon(false);
                    })
                }
            }

        } catch (error) {
            setErrorMessage(error?.message)
            setLoadingMessage("")
            setShowLoadingIcon(false)
        }

    }

    const onSubmitClick = async () => {
        if (isFileSelected) {
      
        // If mandatory documents to be uploaded make sure they are attached before allowing them to submit 
        const mandatoryDocsAttribute = processData?.custom_attributes?.find(
            attr => attr.attribute_type === 'MandatorySupportingDocuments'
        );

        let requiredTypes;
        let uploadedFileTypes;
        if (mandatoryDocsAttribute?.attribute) {
            requiredTypes = mandatoryDocsAttribute.attribute.split(',');
            uploadedFileTypes = supportingDocs.map(file => {
                const extension = file.name.split('.').pop().toLowerCase();
                // Map file extensions to document types
                switch(extension) {
                    case 'doc':
                    case 'docx':
                        return 'Word';
                    case 'xlsm':
                    case 'xlsb':
                    case 'xls':
                    case 'xlsx':
                        return 'Excel';
                    case 'pdf':
                        return 'PDF';
                    case 'csv':
                        return 'CSV';
                    default:
                        return extension;
                }
            });
        // Check if all required types are present
        const missingTypes = requiredTypes.filter(
            type => !uploadedFileTypes.includes(type)
        );

        if (missingTypes.length > 0) {
            setMissingMandatoryDocs(missingTypes)
            return;
        }
        
    };



            try {
                let res = await getAssociatedTANCSessionSync(pid, 'FRISCO')
                if (res?.items?.[0]?.isLocked && res?.items?.[0]?.lockedBy != userId) {
                    setMainErrorMessage(`File upload failed because the TANC session is locked`)
                    return
                }
            } catch (e) {

            }
            setSubmitDisabled(true)
            let quarter = null
            if (processData?.next_step == 'CORP_ADMIN_APPROVAL') {
                quarter = getQuarterForUpload()
            }
            let s3_config = getFriscoS3Config()
            let bucket_name = s3_config.S3.aws_user_files_s3_bucket
            setLoadingMessage("submitting..")
            setShowLoadingIcon(true)
            if(!stageSessionId.current && processData[PROCESS_KEYS.environment] !== "Transfer_FAST_RedShift"){
                stageSessionId.current = uuidv4()
            }

            if (supportingDocs?.length > 0) {
                setLoadingMessage("uploading supporting documents..")
                for (let i = 0; i < supportingDocs?.length; i++) {
                    const file = supportingDocs[i]
                    let fileExt = file.name.split('.').pop()
                    let folder = `stage/${stageSessionId.current}/supportingDocuments/`
                    let fileName = folder + file.name
                    let level = "public"
                    let prefix = 'frisco/'
                    // upload to S3 path
                    let putResp = await Storage.vault.put(fileName, file, {
                        tagging: `userId=${userId}&app_id:${id}&process_id:${pid}&mappingId=${mappingId}&type=${file.type}`,
                        level: level,
                        customPrefix: { public: prefix },
                        acl: 'bucket-owner-full-control'
                    })
                }
            }
            setLoadingMessage("submitting the request..")
            friscoSubmit(stageSessionId.current, id, pid, FRISCO_STATUS.UPLOADED, bucket_name, uploadedFileName, stageSessionFileExt.current,
                Date.now(), userId, uploadedFileName, stageSessionSelectedSheet.current, quarter, taskId, null, null, wbType,
                function onSuccess(response) {
                    setFileReference(JSON.parse(response.data.friscoSubmit)?.fileId)
                    setShowSuccessModal(true)
                    setShowLoadingIcon(false)
                    setSubmitDisabled(false)
                    setWbType(null)
                    setSupportingDocs([])
                    if (tancInfo?.status) {
                        lockSession('TANC')
                    }
                }, function onFailure(response) {
                    setMainErrorMessage(`File upload failed, fileId : ${sessionId}`)
                    setShowLoadingIcon(false)
                    setSubmitDisabled(false)
                })
        }

    }

    const unlockSession = (message = "Releasing lock for the session from Accounting central") => {
        if (sessionDetails?.sessionId) {
            createAuditLog(`TANC_SESSION#${sessionDetails.sessionId}`, `UNLOCK_SESSION#${Date.now()}`, message, JSON.stringify(sessionDetails), null, "TANK UNLOCK SESSION ON UI", userId)
            updateTANCLock(sessionDetails.sessionId, false, null, null, function onSuccess(response) {
                setSessionDetails({ ...sessionDetails, isLocked: response?.data?.updateTANCLock?.isLocked, lockedBy: response?.data?.updateTANCLock?.lockedBy })
            }, function onFailure(response) {
                setAnnotationError("Failed to unlock!")
            })
        }
    }

    const lockSession = (alias = userId) => {
        if (sessionDetails?.sessionId) {
            createAuditLog(`TANC_SESSION#${sessionDetails.sessionId}`, `LOCK_SESSION#${Date.now()}`, "Acquiring lock for the session from Accounting central via upload", JSON.stringify(sessionDetails), null, "TANK LOCK SESSION ON UI UPLOAD", userId)
            updateTANCLock(sessionDetails.sessionId, true, alias, "Uploading data", function onSuccess(response) {
                setSessionDetails({ ...sessionDetails, isLocked: response?.data?.updateTANCLock?.isLocked, lockedBy: response?.data?.updateTANCLock?.lockedBy })
            }, function onFailure(response) {
                setAnnotationError("Failed to lock!")
            })
        }
    }

    const prevButtonClick = () => {
        setActiveTabId('first')
        setShowSuccessModal(false)
        setDisableProceedButton(false)
        // unlock session if any
        unlockSession("Releasing lock after clicking cancel in FRISCO upload page")
    }

    const cancelButtonClick = () => {
        setActiveTabId('first')
        setShowSuccessModal(false)
        setIsFileSelected(false)
        setInputFiles([])
        setSelectedSheet('')
        setInputSheets([])
        setMainErrorMessage('')
        stageSessionFileExt.current = null
        stageSessionId.current = null
        setDisableProceedButton(false)

        // unlock session if any
        unlockSession("Releasing lock after clicking cancel in FRISCO upload page")
    }

    const next1Click = () => {

        setActiveTabId('third')

    }

    const ModalOkClick = () => {
        // Check if we have sidebar content (query parameter context)
        if (props.selectedSidebarContent) {
            // Find the History tab and trigger its action
            const historyTab = props.selectedSidebarContent.find(
                tab => tab.label.toLowerCase() === 'history'
            );
            
            if (historyTab && historyTab.action) {
                // Close the modal first
                setShowSuccessModal(false);
                // Trigger the History tab action (updates parent state + URL)
                historyTab.action();
            } else {
                // Fallback if History tab not found
                setShowSuccessModal(false);
                history.push(`/App/${id}/process/${pid}/history${location.search}`);
            }
        } else {
            // Fallback to original behavior if not in query parameter context
            history.push(`/App/${id}/process/${pid}/history${location.search}`);
        }
    }


    const getSupportedFormats = (input = processData, defValue = '.csv') => {
        let returnValue = new Set()
        returnValue.add(defValue)
        if (input && input.hasOwnProperty(PROCESS_KEYS.file_types) && input[PROCESS_KEYS.file_types]) {
            input[PROCESS_KEYS.file_types].forEach((item) => {
                if (item == 'CSV') {
                    returnValue.add('.csv')
                } else if (item == 'Excel') {
                    returnValue.add('.xls')
                    returnValue.add('.xlsx')
                    // returnValue.add('.xlsb')
                    returnValue.add('.xlsm')
                    // returnValue.add('.xltx')
                    // returnValue.add('.xltm')
                } else if( item === 'PDF'){
                    returnValue.add(".pdf")
                } else if( item === 'Word'){
                    returnValue.add(".docx")
                    returnValue.add(".docm")
                    returnValue.add(".doc")
                } 
            })
        }
        return Array.from(returnValue).join(",")
    }
    const onFollowHandler = (ev) => {
        ev.preventDefault();
        if (ev.detail.href) {
            history.push(ev.detail.href);
        }
    }

    function getTempFile(data, fileName = `updated`) {
        // Remove specific columns
        const lines = data.split('\n');
        const headers = lines[0].split(',').map(h => h.replace(/["]/g, '').trim());
        const columnsToRemove = ['frisco_fast_load_ts', 'file_id'];
        const removeIndices = columnsToRemove.map(col => headers.indexOf(col)).filter(i => i !== -1);

        const keepIndices = headers.map((_, i) => i).filter(i =>
            !columnsToRemove.includes(headers[i])
        );

        const filteredData = lines.map(line => {
            const cols = line.split(',');
            return keepIndices.map(i => cols[i] || '').join(',');
        }).join('\n');


        const blob = new Blob([filteredData], { type: 'text/csv' });
        const tempFile = new File([blob], `${fileName}.csv`, { type: 'text/csv' });
        return tempFile
    }

    async function tancSubmit(data, dataAltered, fileName) {
        lockSession()
        let tempFile = getTempFile(data, fileName)
        let tempFileAltered = getTempFile(dataAltered, `${fileName}_${Date.now().toString()}`)
        changeHandler([tempFile], [tempFileAltered]);
    }

    function tancSubmitAltered(data, fileName) {
        lockSession()
        let tempFile = getTempFile(data, fileName)
        changeHandler([tempFile], [tempFile]);
    }

    // Process Comment Functions using custom_attributes
    const handleProcessCommentUpdate = (commentText, onSuccess, onFailure) => {
        setIsCommentSubmitting(true);
        updateProcessComment(
            pid, 
            commentText, 
            userId,
            (result) => {
                // Success callback - reload process data to get updated comment
                setIsCommentSubmitting(false);
                loadData();
                if (onSuccess) {
                    onSuccess(result);
                }
            },
            (error) => {
                // Failure callback
                setIsCommentSubmitting(false);
                console.error('Error updating process comment:', error);
                if (onFailure) {
                    onFailure(error);
                }
            }
        );
    };

    const renderCertificationSection = (showTitle = false) => {
        if (!requireCertificationCheck) return null;
        
        return (
            <Alert statusIconAriaLabel="Info" header="">
                {showTitle && <Box variant='h5'>Certification</Box>}
                <Checkbox
                    onChange={({ detail }) => setCertificationChecked(detail.checked)}
                    checked={certificationChecked}
                >
                    <strong>I, {userId} (uploader), certify that the deliverable has been reviewed by {approverNames.filter(item => item.column_index === 0).map(item => item.alias).join(', ')} (reviewer) and approved by {approverNames.filter(item => item.column_index === 1).map(item => item.alias).join(', ')} (approver).</strong>
                </Checkbox>
            </Alert>
        );
    };

    const friscoUploadView = (
        <ColumnLayout borders="vertical" columns={2} >
            <SpaceBetween direction='vertical' size='m'>
                {showFileNotSeleted ? <Alert type='error'>File Not Selected</Alert> : ''}
                {
                    showUploadBtn ? <FileUpload
                        onChange={({ detail }) => {
                            setInputFiles(detail.value);
                            setSelectedSheet(''); setInputSheets([]);
                            changeHandler(detail.value)
                        }}
                        value={inputFiles}
                        i18nStrings={{
                            uploadButtonText: e =>
                                e ? "Choose files" : "Choose file",
                            dropzoneText: e =>
                                e
                                    ? "Drop files to generate"
                                    : "Drop file to generate",
                            removeFileAriaLabel: e =>
                                `Remove file ${e + 1}`,
                            limitShowFewer: "Show fewer files",
                            limitShowMore: "Show more files",
                            errorIconAriaLabel: "Error"
                        }}
                        showFileLastModified
                        showFileSize
                        showFileThumbnail
                        tokenLimit={1}
                        accept={supportedFormats}
                        constraintText="upload input file"
                    /> : <Box></Box>
                }
                {inputSheets && inputSheets.length > 0 ?
                    <SpaceBetween size='s'>
                        <Box variant='h5'> Please choose a sheet from the uploaded file for processing, and click proceed</Box>
                        <Tiles
                            onChange={({ detail }) => {
                                setSelectedSheet(detail.value)
                            }}
                            value={selectedSheet}
                            items={inputSheets}
                        />
                    </SpaceBetween> : <></>
                }
                { processData && processData?.file_types && processData.file_types.length >0 &&
                    <Alert
                        statusIconAriaLabel="Info"
                        header="Allowed File Upload Types"
                    >
                        The following file types are allowed for Upload:
                        <ul>
                            {processData.file_types.map(fileType => <li key={fileType}>{fileType}</li>)}
                        </ul>
                    </Alert>
                }
                {inputSheets && inputSheets.length >0 && (
                    <Box float="right">
                        <Button variant="primary" disabled={disableProceedButton} onClick={processExcelSheet} >Proceed</Button>
                    </Box>
                )}

                {
                    comments ? <Alert
                        statusIconAriaLabel="Info"
                        header="Dates"
                    >
                        {comments?.split("\n")?.map((t, key) => {
                            return <p key={key}>{t}</p>;
                        })}


                    </Alert> : ''
                }

                {errorMessage ? <Alert statusIconAriaLabel="Error"
                    type="error"
                    header="Upload restricted">
                    {errorMessage} </Alert> : ''}

                {
                    emptyColumnIndices?.length > 0 && <Alert type="error">
                        Empty columns found. Column index: {emptyColumnIndices?.join(',')}
                    </Alert>
                }


                {(missingFields?.size >= 1 || colCountMoreThanExpected || colsNotInRequiredOrder || Object.keys(comparisonValidationErrors).length > 0) ? (
                    <>
                        <Box>
                            <h4>Validation checks:</h4>
                            <ul>
                                <li>
                                    All required fields available? {missingFields.size >= 1 ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                                <li>
                                    Provided column(s) count is less than or equal to expected column count? {colCountMoreThanExpected ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                                <li>
                                    Empty column(s) name found? {emptyColumnIndices?.length > 0 ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                                <li>
                                    Column order as expected? (Please refer required column order on the right) {colsNotInRequiredOrder ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                                <li>
                                    Column value validation passed? {Object.keys(comparisonValidationErrors).length > 0 ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                            </ul>
                        </Box>
                        {
                            (missingFields.size >= 1 &&

                                <Alert
                                    statusIconAriaLabel="Error"
                                    type="error"
                                    header="Required fields are missing"
                                >
                                    <SpaceBetween>
                                        <Box><h4>Missing columns:</h4>
                                            <ul>
                                                {Array.from(missingFields).map((field) => (
                                                    <li key={field}>{field}</li>
                                                ))}
                                            </ul>
                                        </Box>
                                        <Box><h4>Provided columns:</h4>
                                            <ul>
                                                {providedCoulumns.map((field) => (
                                                    <li key={field}>{field}</li>
                                                ))}
                                            </ul>
                                        </Box>
                                    </SpaceBetween>
                                </Alert>
                            )
                        }
                        {
                            (Object.keys(comparisonValidationErrors).length > 0 &&
                                <Alert
                                    statusIconAriaLabel="Error"
                                    type="error"
                                    header="Column value validation failed"
                                >
                                    <SpaceBetween>
                                        {Object.entries(comparisonValidationErrors).map(([columnName, errors]) => (
                                            <Box key={columnName}>
                                                <h4>Column: {columnName}</h4>
                                                <p>Expected all values to be: <strong>{errors[0]?.expected_value}</strong></p>
                                                <p>Found {errors.length} row(s) with incorrect values:</p>
                                                <ul>
                                                    {errors.slice(0, 10).map((error, index) => (
                                                        <li key={index}>
                                                            Row {error.row_index}: "{error.actual_value}" (expected "{error.expected_value}")
                                                        </li>
                                                    ))}
                                                    {errors.length > 10 && (
                                                        <li>... and {errors.length - 10} more rows with validation errors</li>
                                                    )}
                                                </ul>
                                            </Box>
                                        ))}
                                    </SpaceBetween>
                                </Alert>
                            )
                        }
                        {
                            providedCoulumns.length > 0 ?
                                <SpaceBetween>

                                </SpaceBetween>
                                : <></>
                        }


                    </>
                ) : <></>

                }

            </SpaceBetween>





            {processData[PROCESS_KEYS.environment] == "Transfer_FAST_RedShift" &&(
                <Box>
                    <ExpandableSection header="The file should contain the following columns in below order."
                        defaultExpanded>
                        <ColumnLayout columns={2}>
                            <SpaceBetween direction='vertical'>
                                <Box variant="awsui-key-label" > &nbsp;</Box>
                                <ul>
                                    {
                                        Array.from(getMandatoryColumnNames()).map(
                                            column => <li
                                                value={column}
                                                key={column}>
                                                <span>{column}</span>
                                                <span className='missing'> {(missingFields && missingFields.size > 0 && missingFields.has(column)) ? ' - required' : ''} </span>
                                            </li>
                                        )
                                    }
                                </ul>
                            </SpaceBetween>

                            {
                                providedCoulumns.length > 0 ?
                                    <SpaceBetween direction='vertical'>
                                        <Box variant="awsui-key-label" >Provided columns</Box>
                                        <ul>
                                            {
                                                Array.from(providedCoulumns).map(
                                                    column => <li
                                                        value={column}
                                                        key={column}>
                                                        <span>{column}</span>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </SpaceBetween> : <></>
                            }
                        </ColumnLayout>
                    </ExpandableSection>
                </Box>
            )}
        </ColumnLayout>
    )

    const getUploadTabs = () =>{
        const environment = processData[PROCESS_KEYS.environment]
        let tabs = []
        
        if(environment === 'Transfer_FAST_RedShift'){
            // Original multi-tab flow for Transfer_FAST_RedShift
            tabs.push(
                {
                    activeTabId: { activeTabId },
                    label: `Step 1 : Upload File`,
                    id: "first",
                    content: (
                        <div>
                            <SpaceBetween direction='vertical'>
                                {
                                    uploadSegment == 'tanc' ? <TANCSession sessionDetails={sessionDetails} tancDetails={tancInfo} showSave={false} showSubmit={true} onSubmit={processData[PROCESS_KEYS.action] == 'DELSERT' ? null : tancSubmit} onSubmitAltered={processData[PROCESS_KEYS.action] == 'DELSERT' ? tancSubmitAltered : null}></TANCSession> : <Box><br></br> {friscoUploadView}</Box>
                                }
                            </SpaceBetween>
                        </div>
                    )
                }
            )
            
            tabs.push(
                {
                    label: currentAppId == appSettings[currentStage]['appId'] ? "Step 2 : Validate Datasheet" : "Step 2 : Review File",
                    id: "second",
                    content: (
                        <Box>
                            <Header
                                variant="h2"
                                description="File preview - Read Only"
                                actions={
                                    <SpaceBetween
                                        direction="horizontal"
                                        size="xs"
                                    >
                                        <Button variant="normal" onClick={prevButtonClick}>Previous</Button>
                                        <Button variant="primary" onClick={next1Click}>Next</Button>
                                        <Box></Box>
                                    </SpaceBetween>
                                }
                            />
                            <br />
                            <SpaceBetween direction='vertical' size='m'>
                                <Alert type="info">
                                    Please review your upload for accuracy before proceeding to next step
                                </Alert>
                                {
                                    emptyRowsValidationResult?.has_empty_rows && <Alert type="warning">
                                        There are {emptyRowsValidationResult?.count} empty row(s) in the input.
                                    </Alert>
                                }
                            </SpaceBetween>
                            <br />
                            <Table
                                columnDefinitions={columnsList}
                                items={previewItems}
                                stickyHeader={true}
                                resizableColumns={true}
                            >
                            </Table>
                        </Box>
                    )
                }
            )
            
            tabs.push(
                {
                    label: currentAppId == appSettings[currentStage]['appId'] ? "Step 3 : Upload Supporting Files and Submit" : "Step 3 : Submit",
                    id: "third",
                    content: (<div>
                        <Header
                            variant="h2"
                            description="Upload Details"
                        />
                        <SpaceBetween direction='vertical' size='l'>
                            < Box>
                                Filename: {uploadedFileName}
                                {mainErrorMessage && (
                                    <div className="custom-new-upload__error-message"> {mainErrorMessage} </div>
                                )}
                            </Box>
                                {
                                    shouldShowWbSelection ?
                                        <RadioGroup
                                            onChange={({ detail }) => setWbType(detail.value)}
                                            value={wbType}
                                            items={getFilteredWbOptionsPlugin(processData)}
                                        /> : <></>
                                }
                                {
                                    shouldShowPdfUpload ?
                                        <SpaceBetween size="s">
                                            <FileInput
                                                onChange={({ detail }) => {
                                                    setSupportingDocs([...supportingDocs, ...detail.value])
                                                    setMissingMandatoryDocs([])
                                                }}
                                                value={supportingDocs}
                                                multiple
                                            >
                                                Upload supporting documents
                                            </FileInput>
                                            <Table
                                                columnDefinitions={[
                                                    {
                                                        id: "name",
                                                        header: "File name",
                                                        cell: file => file.name
                                                    },
                                                    {
                                                        id: "size",
                                                        header: "File size",
                                                        cell: file => file.size / 1000 + "KB"
                                                    },
                                                    {
                                                        id: "delete",
                                                        header: "",
                                                        cell: (file) => (
                                                        <Button
                                                            iconName="close"
                                                            variant="icon"
                                                            onClick={() => {
                                                                setSupportingDocs((currentDocs) =>
                                                                currentDocs.filter((doc) => doc !== file)
                                                                );
                                                            }}
                                                            ariaLabel={`Delete ${file.name}`}
                                                        />
                                                    )}
                                                ]}
                                                items={supportingDocs}
                                                empty="No files"
                                            />
                                            <br/>
                                            {  processData?.custom_attributes?.find(attr => attr.attribute_type === 'MandatorySupportingDocuments')?.attribute?.length >0  &&
                                                <Alert
                                                    statusIconAriaLabel="Info"
                                                    header="Required file types"
                                                >
                                                    Please upload the following types files: 
                                                    <ul>
                                                        {processData?.custom_attributes?.find(
                                                            attr => attr.attribute_type === 'MandatorySupportingDocuments'
                                                        )?.attribute.split(',').map((field) => (
                                                            <li key={field}>{field}</li>
                                                        ))}
                                                    </ul>
                                                </Alert>
                                            }
                                            {
                                                (missingMandatoryDocs.length >= 1 &&
                                                    <Alert
                                                        statusIconAriaLabel="Error"
                                                        type="error"
                                                        header="Required file types are missing"
                                                    >
                                                        <SpaceBetween>
                                                            <Box><h4>Missing file types:</h4>
                                                                <ul>
                                                                    {Array.from(missingMandatoryDocs).map((field) => (
                                                                        <li key={field}>{field}</li>
                                                                    ))}
                                                                </ul>
                                                            </Box>
                                                        </SpaceBetween>
                                                    </Alert>
                                                )
                                            }
                                        </SpaceBetween> : <></>
                                }
                                {
                                    approverNames?.length > 0 && (
                                        <SpaceBetween direction='vertical' size='m'>
                                            {
                                                currentAppId == appSettings[currentStage]['appId'] && <Alert
                                                    type="warning"
                                                    header="Important Notice"
                                                >
                                                Please verify assigned approvers before submitting the file(s) and contact the SEC team if any changes are necessary. Changing approvers after submission may require re-upload.
                                                </Alert>
                                            }
                                        {renderCertificationSection()}
                                    </SpaceBetween>
                            )}
                    </SpaceBetween>
                    <br/>
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="normal" onClick={cancelButtonClick} disabled={submitDisabled}>Cancel</Button>
                            <Button variant="primary" onClick={onSubmitClick} disabled={submitDisabled || (shouldShowWbSelection && !wbType) || (requireCertificationCheck && approverNames?.length > 0 && !certificationChecked)}>Submit</Button>
                        </SpaceBetween>
                    </div>)
                }
            )
        } else {
            // Single tab with all content for non-Transfer_FAST_RedShift environments
            tabs.push(
                {
                    activeTabId: { activeTabId },
                    label: `Upload and Submit`,
                    id: "first",
                    content: (
                        <div>
                            <SpaceBetween direction='vertical' size='l'>
                                <>{errorsContent}</>
                                {
                                    uploadSegment == 'tanc' ? <TANCSession sessionDetails={sessionDetails} tancDetails={tancInfo} showSave={false} showSubmit={true} onSubmit={processData[PROCESS_KEYS.action] == 'DELSERT' ? null : tancSubmit} onSubmitAltered={processData[PROCESS_KEYS.action] == 'DELSERT' ? tancSubmitAltered : null}></TANCSession> : 
                                    <SpaceBetween direction='vertical' size='l'>
                                        <Container
                                            header={
                                                <Header
                                                    variant="h3"
                                                    description="File Details"
                                                />
                                            }
                                        >
                                            <SpaceBetween direction='vertical' size='l'>
                                                <Box>
                                                    {mainErrorMessage && (
                                                        <div className="custom-new-upload__error-message"> {mainErrorMessage} </div>
                                                    )}
                                                </Box>
                                                    {
                                                        shouldShowWbSelection ?
                                                            <RadioGroup
                                                                onChange={({ detail }) => setWbType(detail.value)}
                                                                value={wbType}
                                                                items={getFilteredWbOptionsPlugin(processData)}
                                                            /> : <></>
                                                    }
                                                    {
                                                        shouldShowPdfUpload ?
                                                            <SpaceBetween size="s">
                                                                <FileInput
                                                                    onChange={({ detail }) => {
                                                                        setSupportingDocs([...supportingDocs, ...detail.value])
                                                                        setMissingMandatoryDocs([])
                                                                        if (detail.value.length > 0) {
                                                                            setIsFileSelected(true)
                                                                            setUploadedFileName(detail.value[0].name)
                                                                        }
                                                                    }}
                                                                    value={supportingDocs}
                                                                    multiple
                                                                >
                                                                    Upload File(s)
                                                                </FileInput>
                                                                <Table
                                                                    columnDefinitions={[
                                                                        {
                                                                            id: "name",
                                                                            header: "File name",
                                                                            cell: file => file.name
                                                                        },
                                                                        {
                                                                            id: "size",
                                                                            header: "File size",
                                                                            cell: file => file.size / 1000 + "KB"
                                                                        },
                                                                        {
                                                                            id: "delete",
                                                                            header: "",
                                                                            cell: (file) => (
                                                                            <Button
                                                                                iconName="close"
                                                                                variant="icon"
                                                                                onClick={() => {
                                                                                    if (processData[PROCESS_KEYS.environment] !== 'Transfer_FAST_RedShift') {
                                                                                        // For non-Transfer_FAST_RedShift: handle both main and supporting files
                                                                                        if (inputFiles.includes(file)) {
                                                                                            setInputFiles((currentFiles) => currentFiles.filter((f) => f !== file));
                                                                                            setIsFileSelected(false);
                                                                                            setUploadedFileName('');
                                                                                        } else {
                                                                                            setSupportingDocs((currentDocs) => currentDocs.filter((doc) => doc !== file));
                                                                                        }
                                                                                    } else {
                                                                                        // Original behavior for Transfer_FAST_RedShift
                                                                                        setSupportingDocs((currentDocs) => currentDocs.filter((doc) => doc !== file));
                                                                                    }
                                                                                }}
                                                                                ariaLabel={`Delete ${file.name}`}
                                                                            />
                                                                        )}
                                                                    ]}
                                                                    items={supportingDocs}
                                                                    empty="No files"
                                                                />
                                                                <br/>
                                                                {  processData?.custom_attributes?.find(attr => attr.attribute_type === 'MandatorySupportingDocuments')?.attribute?.length >0  &&
                                                                    <Alert
                                                                        statusIconAriaLabel="Info"
                                                                        header="Required file types"
                                                                    >
                                                                        Please upload the following types files: 
                                                                        <ul>
                                                                            {processData?.custom_attributes?.find(
                                                                                attr => attr.attribute_type === 'MandatorySupportingDocuments'
                                                                            )?.attribute.split(',').map((field) => (
                                                                                <li key={field}>{field}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </Alert>
                                                                }
                                                                {
                                                                    (missingMandatoryDocs.length >= 1 &&
                                                                        <Alert
                                                                            statusIconAriaLabel="Error"
                                                                            type="error"
                                                                            header="Required file types are missing"
                                                                        >
                                                                            <SpaceBetween>
                                                                                <Box><h4>Missing file types:</h4>
                                                                                    <ul>
                                                                                        {Array.from(missingMandatoryDocs).map((field) => (
                                                                                            <li key={field}>{field}</li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </Box>
                                                                            </SpaceBetween>
                                                                        </Alert>
                                                                    )
                                                                }
                                                            </SpaceBetween> : <></>
                                                    }
                                                {
                                                    approverNames?.length > 0 && uploadAccessForTheQuarter && (
                                                        <SpaceBetween direction='vertical' size='m'>
                                                            {
                                                                currentAppId == appSettings[currentStage]['appId'] &&  <Alert
                                                                type="warning"
                                                                header="Important Notice"
                                                            >
                                                                Please verify assigned approvers before submitting the file(s) and contact the SEC team if any changes are necessary. Changing approvers after submission may require re-upload.
                                                            </Alert>
                                                            }
	                                                     {renderCertificationSection()}
	                                                 </SpaceBetween>
                                                )}
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    <Button variant="normal" onClick={cancelButtonClick} disabled={submitDisabled}>Cancel</Button>
                                                    <Button variant="primary" onClick={onSubmitClick} disabled={submitDisabled || !isFileSelected || (shouldShowWbSelection && !wbType) || (requireCertificationCheck && approverNames?.length > 0 && !certificationChecked)}>Submit</Button>
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        </Container>
                                    </SpaceBetween>
                                }
                            </SpaceBetween>
                        </div>
                    )
                }
            )
        }

        return tabs
    }

    const errorsContent = (
        <>
            {isFriscoDisabled && <>
                {
                    disabledMessages?.length > 0 ?
                        <SpaceBetween size='xs' direction='vertical'>{disabledMessages.map((message) => <Alert type='error'>{message}</Alert>)}</SpaceBetween> :
                        <Box>This FRISCO is disabled. Please contact the process owner for more details.</Box>
                }
            </>
            }
            {errorMessage ? <Alert statusIconAriaLabel="Error"
                type="error"
                header="Upload restricted">
                {errorMessage} </Alert> : ''}

            </>
    )

    const content = (
        <div>
            {!props.disableAppLayout && (
                <BreadcrumbGroup
                    items={breadcrumbItems}
                    onFollow={onFollowHandler}
                />
            )}
            <div>
                <SpaceBetween size='xs'>
                        
                    {/* Process Comment Section using custom_attributes */}
                    {/* {!isFriscoDisabled && (
                        <ProcessCommentSection
                            processData={processData}
                            processType="FRISCO"
                            onCommentUpdate={handleProcessCommentUpdate}
                            isAteamBiMember={isSupportAdmin}
                            loading={showLoadingIcon}
                            isSubmitting={isCommentSubmitting}
                        />
                    )} */}
                   
                    <Flashbar
                        items={notificationBarItems}
                        i18nStrings={{
                            ariaLabel: "Notifications",
                            notificationBarAriaLabel:
                                "View all notifications",
                            notificationBarText: "Notifications",
                            errorIconAriaLabel: "Error",
                            warningIconAriaLabel: "Warning",
                            successIconAriaLabel: "Success",
                            infoIconAriaLabel: "Info",
                            inProgressIconAriaLabel: "In progress"
                        }}
                        stackItems
                    />
                    <Container
                        header={
                            <Header
                                variant='h2'
                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant='normal' onClick={() => { 
                                            if (props.selectedSidebarContent) {
                                                const historyTab = props.selectedSidebarContent.find(
                                                    tab => tab.label.toLowerCase() === 'history'
                                                );
                                                
                                                if (historyTab && historyTab.action) {
                                                    historyTab.action();
                                                } else {
                                                    history.push(`/App/${id}/process/${pid}/history`);
                                                }
                                            } else {
                                                history.push(`/App/${id}/process/${pid}/history`);
                                            }
                                        }}>
                                            View Upload History
                                        </Button>
                                    </SpaceBetween>
                                }
                                description=""
                            > Upload file for process- {getProcessDisplayName()}
                            </Header>
                        }
                    >
                        <Grid gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}>
                            {
                                processData?.hasOwnProperty(PROCESS_KEYS.team) && processData?.hasOwnProperty(PROCESS_KEYS.business)
                                    && processData?.hasOwnProperty(PROCESS_KEYS.dataset_name) && processData[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift' && !hideLoadTable ?
                                    <SpaceBetween size='s' direction='horizontal'>
                                        <Box variant="h4"> Load table : </Box>
                                        {
                                            processData[PROCESS_KEYS.redshift_table_name] ?
                                                <Box>{processData[PROCESS_KEYS.redshift_table_name]}</Box> :
                                                <Box variant="p"> {processData[PROCESS_KEYS.team]}_{processData[PROCESS_KEYS.business]}_{processData[PROCESS_KEYS.dataset_name]}</Box>
                                        }
                                    </SpaceBetween> : <></>
                            }
                            {
                                sessionDetails?.status == 'ACTIVE' && !props.disableAppLayout ? <Box float="right">
                                    <SpaceBetween direction='horizontal' size='xs'>
                                        <SegmentedControl
                                            selectedId={uploadSegment}
                                            onChange={({ detail }) =>
                                                setUploadSegment(detail.selectedId)
                                            }
                                            label="Default segmented control"
                                            options={[
                                                { text: "Upload", id: "upload", disabled: !showUploadBtn },
                                                { text: "Inline edit", id: "tanc", disabled: !showUploadBtn || (tancInfo?.status ? false : true) },
                                            ]}
                                        />
                                        {
                                            sessionDetails && !sessionDetails?.s3Uri ?
                                                <Popover
                                                    dismissButton={false}
                                                    position="top"
                                                    size="small"
                                                    triggerType="custom"
                                                    content={
                                                        <Box>Enable Inline editing in FRISCO configuration</Box>
                                                    }
                                                >
                                                    <Icon name="security" />
                                                </Popover> : <></>
                                        }
                                    </SpaceBetween>
                                </Box> : <></>
                            }

                        </Grid>

                    </Container>

                    {showLoadingIcon ? (
                        <Box>
                            <Spinner size="normal"></Spinner>
                            {loadingMessage}
                        </Box>) : ''}
                    {isFriscoDisabled && <>
                        {
                            disabledMessages?.length > 0 ?
                                <SpaceBetween size='xs' direction='vertical'>{disabledMessages.map((message) => <Alert type='error'>{message}</Alert>)}</SpaceBetween> :
                                <Box>This FRISCO is disabled. Please contact the process owner for more details.</Box>
                        }
                    </>
                    }

                    
                    {
                        !isFriscoDisabled && <Tabs
                        activeTabId={activeTabId}
                        variant='container'
                        onChange={(event)=> {
                            if(event.detail.activeTabId ==="first"){
                                prevButtonClick()
                            }
                            else if(event.detail.activeTabId ==="second" && activeTabId === 'third'){
                                setActiveTabId('second')
                            }
                        }}
                        tabs={getUploadTabs()}
                    />
                    }
                </SpaceBetween>
                <Modal
                    visible={showSuccessModal}
                    footer={
                        <Box float="right">
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button variant="primary" onClick={ModalOkClick}>Ok</Button>
                            </SpaceBetween>
                        </Box>
                    }
                    header="File Upload Status"
                >
                    <Box>
                        <SpaceBetween size='m' direction='vertical'>
                            <p>
                                <Icon variant="success" size='medium' name='status-positive'></Icon>
                                &nbsp; &nbsp;
                                Your file has been uploaded for processing. <br></br>
                                File reference : {fileReference}
                            </p>

                        </SpaceBetween>

                    </Box>

                    <br></br>

                </Modal>
            </div>
        </div>
    )


    return (
        <AppLayout
            content={content}
            navigation={<SideNav activeHref={`/App/${id}/process/${pid}/upload`} id={id} pid={pid} process={processData} back={backUrl} />}
            headerSelector="#TopBar"
            navigationHide={props.disableAppLayout}
            disableBodyScroll={true}
            toolsHide={true}
            headerVariant="high-contrast"
            contentType="table"
        ></AppLayout>
    );
}
